<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div v-if="show" class="animated fadeIn">
          <vs-table ref="table" :params="params" :options="options"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  //@import '~vuejs-noty/dist/vuejs-noty.css';

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
<script>
  import VsTable from "../_framework/VsTable.vue";
  import VsTableMixin from "../_framework/VsTableMixin.js";
  import axios from "axios";
  import BaseService from "../_framework/api/BaseService.js";

  export default {
    name :"manage-orders",
    props: ["accesses", "userAccess"],
    components: {
      VsTable,
      VsTableMixin
    },
    mixins: [VsTableMixin],
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      //console.log(this.options.access);
      // this.show = !!this.options.access;
    },
    data() {
      return {
        show: true,

        params: {
          entity: "ProductionManagements",
          reqUrl: "/GetManageOrder",
          headers: {
            // id: {
            //     title: 'شماره مشتری',
            //     type: 'number',
            //     rowAlignment: 'center',
            // },
            product: {
              title: "نام کالا",
              type: "custom",
              component: "product-view",
              rowAlignment: "center"
            },
            orderCode: {
              title: "کد سفارش",
              type: "text",
              rowAlignment: "center"
            },
            customer: {
              title: "نام سفارش دهنده",
              type: "custom",
              component: "customer-view",
              rowAlignment: "center"
            },
            unitVal: {
              title: "تعداد",
              type: "number",
              rowAlignment: "center"
            },
            deliveryDate: {
              title: "تاریخ تحویل",
              type: "number",
              rowAlignment: "center",
              formatGregorianDateToJalaali: true
            },
            inventoryStatus: {
              title: "",
              inHeader: false,
              component: "inner-box-toggler",
              label: "وضعیت انبار",
              rowAlignment: "center",
              triggersRowClickEvent: true
            }
          }
        },
        options: {
          hasActions: false,
          clickableRows: false,
          sortableHeaders: true,
          dataSourceType: "api",
          innerBox: {
            component: "inventory-details"

          },
          beforeUpdateEntity: input => {
            this.refreshTable();
            return input;
          },

        }
      };
    },
    mounted() {
      this.refreshTable();
      // this.getOrderList();
      /* setTimeout(() => {
           console.log(this.$refs.table.list.data)
       },1000)*/

    },
    methods: {
      /*getOrderList() {
        new BaseService('ProductionManagements', '/GetManageOrder').getList().then((response) => {
          // console.log(response.data.data)
           /!* this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
            })*!/
        }).catch((error) => {
          console.log(error)
        });
      },*/
      refreshTable() {
        /*this.show = false;
        setTimeout(() => {
            this.show = true;
        }, 500);*/
        // this.$refs.table.onFetchEntityList();
      },
      getFilesInnerBox() {
        let innerBox = {
          options: {
            clickableRows: false,
            hasActions: false,
            isEditable: false
          },
          params: {}
        };

        return innerBox;
      }
    }
  };
</script>

<style lang="scss">
  /*.vs-table-header {*/
  /*background-color: beige;*/
  /*}*/

  /*.vs-table-row {*/
  /*transition: .3s;*/
  /*}*/

  /*.vs-table-row:not(.vs-table-header) {*/
  /*background-color: lightgrey;*/
  /*border-bottom: 1px solid white;*/
  /*}*/

  /*.vs-table-row.selected {*/
  /*background-image: linear-gradient(to right, grey , #a5a5a5);*/
  /*color: white*/
  /*}*/
</style>
